import miscPagesRoutes from "../routes/misc-pages-routes";

var blankLayoutRoutes = [...miscPagesRoutes];

export default blankLayoutRoutes;
